import { urlBaseAccreditation } from "../../config/";
import axiosInstance from "../../../services/config/axiosinstance";
import FaceCollectorConfigModel from '../../../models/FaceCollectorConfigModel';

export default async function getFaceCollectorConfig(
  miceId = '',
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/faceCollectorConfig/getFaceCollectorConfig?eventId=${miceId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return FaceCollectorConfigModel(_ret.data?.data);
  } catch (error) {
    console.log('Error getFaceCollectorConfig', error);
    throw error;
  }
}
